/**
 * Per-animal meter pace (docs/SPEC.md section 3, "Pace per meter"). A pet log stores the curves it was hatched with, so
 * changing a profile here never changes a pet that already exists. Numbers are effective hours; they are a proposal to
 * be tuned in playtests. Every profile obeys the curve rules: ordered phases and a 1% point of at least 20 hours.
 */
import type { CurveProfile } from "./curve";
import type { MeterId } from "./types";

const SHARK: Record<MeterId, CurveProfile> = {
  food: { phase1End: 1.2, phase2End: 7.5, phase3End: 10.5, onePercentAt: 20 },
  fun: { phase1End: 1.5, phase2End: 8.5, phase3End: 11.5, onePercentAt: 21 },
  love: { phase1End: 1.5, phase2End: 9.5, phase3End: 12.5, onePercentAt: 22 },
  rest: { phase1End: 1.8, phase2End: 11, phase3End: 14, onePercentAt: 24 },
  clean: { phase1End: 2, phase2End: 12, phase3End: 15.5, onePercentAt: 26 },
};

const PROFILES: Readonly<Record<string, Readonly<Record<MeterId, CurveProfile>>>> = { shark: SHARK };

/** The curves a newly hatched pet of this animal gets. Unknown animals use the default curve for every meter. */
export function animalCurves(species: string): Record<MeterId, Partial<CurveProfile>> {
  const profile = PROFILES[species];
  if (!profile) return { food: {}, rest: {}, fun: {}, clean: {}, love: {} };
  return {
    food: { ...profile.food },
    rest: { ...profile.rest },
    fun: { ...profile.fun },
    clean: { ...profile.clean },
    love: { ...profile.love },
  };
}
